const services = [
  {
    id: 1,
    translationKey: 'cybersecurity_consulting',
    slug: 'cybersecurity-consulting',
    detailsLink: '/service/cybersecurity-consulting',
    detailsImage: 'assets/img/service/service_single_01.jpg',
    icon: 'assets/img/service/service1.svg',
  },
  {
    id: 2,
    translationKey: 'threat_detection',
    slug: 'threat-detection-and-response',
    detailsLink: '/service/threat-detection-and-response',
    detailsImage: 'assets/img/service/service_single_02.jpg',
    icon: 'assets/img/service/service2.svg',
  },
  {
    id: 3,
    translationKey: 'vulnerability_assessment',
    slug: 'vulnerability-assessment',
    detailsLink: '/service/vulnerability-assessment',
    detailsImage: 'assets/img/service/service_single_03.jpg',
    icon: 'assets/img/service/service3.svg',
  },
  {
    id: 4,
    translationKey: 'incident_response',
    slug: 'incident-response-and-recovery',
    detailsLink: '/service/incident-response-and-recovery',
    detailsImage: 'assets/img/service/service_single_04.jpg',
    icon: 'assets/img/service/service4.svg',
  },
  {
    id: 5,
    translationKey: 'security_training',
    slug: 'security-awareness-training',
    detailsLink: '/service/security-awareness-training',
    detailsImage: 'assets/img/service/service_single_05.jpg',
    icon: 'assets/img/service/service5.svg',
  },
  {
    id: 6,
    translationKey: 'data_security',
    slug: 'data-security-services',
    detailsLink: '/service/data-security-services',
    detailsImage: 'assets/img/service/service_single_06.jpg',
    icon: 'assets/img/service/service6.svg',
  },
  {
    id: 7,
    translationKey: 'endpoint_detection',
    slug: 'endpoint-detection-and-response',
    detailsLink: '/service/endpoint-detection-and-response',
    detailsImage: 'assets/img/service/service_single_07.jpg',
    icon: 'assets/img/service/service7.svg',
  },
  {
    id: 8,
    translationKey: 'threat_intelligence',
    slug: 'threat-intelligence',
    detailsLink: '/service/threat-intelligence',
    detailsImage: 'assets/img/service/service_single_08.jpg',
    icon: 'assets/img/service/service8.svg',
  },
  {
    id: 9,
    translationKey: 'web_firewall',
    slug: 'web-application-firewall',
    detailsLink: '/service/web-application-firewall',
    detailsImage: 'assets/img/service/service_single_09.jpg',
    icon: 'assets/img/service/service9.svg',
  },
];

export default services;
